import React, { useState, useEffect } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import "./AlertModal.css";

export default function AlertModal({
  modalTitle,
  modalBody,
  modalValue,
  onChangeModal,
}) {
  const [modal, setModal] = useState(modalValue);

  const confirm = () => {
    onChangeModal(true);
    setModal(!modal);
  };

  const cancel = () => {
    onChangeModal(false);
    setModal(!modal);
  };

  const toggle = () => {
    onChangeModal(false);
    setModal(!modal);
  };

  useEffect(() => {
    setModal(modalValue);
  }, [modalValue]);

  return (
    <div>
      <Modal isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>{modalTitle}</ModalHeader>
        <ModalBody>{modalBody}</ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={confirm}>
            Ok
          </Button>{" "}
          <Button color="secondary" onClick={cancel}>
            Cancel
          </Button>{" "}
        </ModalFooter>
      </Modal>
    </div>
  );
}
